import React, { useEffect, useState } from "react";
import { boxFetcher } from "../../../api/requests";
import VideoBlockWithTag from "../../Homepage/VideoBlockWithTag";
import VideoBlock from "../../Homepage/VideoBlock";
import TopCategory from "../../Homepage/TopCategory";
import PopularChannels from "../../Homepage/PopularChannels";
import SkeletonLoader from "../SkeletonLoader";
import Campaign from "../../Homepage/Campaign";
import { VideosContextProvider } from "../../../context/videos";

const Section = ({ section }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const sectionComponents = {
    "ویدئوهای ویژه": (data) => (
      <VideoBlock
        data={data}
        nameInView={section.name_in_view}
        type={section.content_type} 
      />
    ),
    "جدیدترین ویدئوها": (data) => (
      <div style={{ padding: "0px 30px" }}>
        <VideoBlockWithTag
          mine={false}
          title={section.name_in_view}
          videosBasedOnCategory={data}
          type={section.content_type}
        />
      </div>
    ),
    "ردیف نخست ویدئوها": (data) => (
      <div style={{ padding: "0px 30px" }}>
        <VideoBlockWithTag
          mine={false}
          title={section.name_in_view}
          videosBasedOnCategory={data}
          categoryId={section.categorys?.id}
          tag={!!section.tags?.id}
          tagId={section.tags?.id}
          lg={4}
          md={3}
          type={section.content_type}
        />
      </div>
    ),
    "ردیف دوم ویدئوها": (data) => (
      <div style={{ padding: "0px 30px" }}>
        <VideoBlockWithTag
          mine={false}
          title={section.name_in_view}
          videosBasedOnCategory={data}
          categoryId={section.categorys?.id}
          tag={!!section.tags?.id}
          tagId={section.tags?.id}
          lg={4}
          md={3}
          type={section.content_type}
        />
      </div>
    ),
    "کانال ها": (data) => (
      <div style={{ padding: "30px 30px 0px" }}>
        <VideosContextProvider>
          <TopCategory
            title={section.name_in_view}
            data={data}
            type={section.content_type}
          />
        </VideosContextProvider>
      </div>
    ),
    "ردیف سوم ویدئوها": (data) => (
      <div style={{ padding: "0px 30px" }}>
        <VideoBlockWithTag
          mine={false}
          title={section.name_in_view}
          videosBasedOnCategory={data}
          categoryId={section.categorys?.id}
          tag={!!section.tags?.id}
          tagId={section.tags?.id}
          lg={4}
          md={3}
          type={section.content_type}
        />
      </div>
    ),
    "ردیف چهارم ویدئوها": (data) => (
      <div style={{ padding: "0px 30px" }}>
        <VideoBlockWithTag
          mine={false}
          title={section.name_in_view}
          videosBasedOnCategory={data}
          categoryId={section.categorys?.id}
          tag={!!section.tags?.id}
          tagId={section.tags?.id}
          lg={4}
          md={3}
          type={section.content_type}
        />
      </div>
    ),
    "کانال های ویژه": (data) => (
      <div style={{ padding: "0px 30px" }}>
        <PopularChannels
          data={data}
          title={section.name_in_view}
          type={section.content_type}
        />
      </div>
    ),
    "ردیف پنجم ویدئوها": (data) => (
      <div style={{ padding: "0px 30px" }}>
        <VideoBlockWithTag
          mine={false}
          title={section.name_in_view}
          videosBasedOnCategory={data}
          categoryId={section.categorys?.id}
          tag={!!section.tags?.id}
          tagId={section.tags?.id}
          lg={4}
          md={3}
          type={section.content_type}
        />
      </div>
    ),
    "ردیف ششم ویدئوها": (data) => (
      <div style={{ padding: "0px 30px" }}>
        <VideoBlockWithTag
          mine={false}
          title={section.name_in_view}
          videosBasedOnCategory={data}
          categoryId={section.categorys?.id}
          tag={!!section.tags?.id}
          tagId={section.tags?.id}
          lg={4}
          md={3}
          type={section.content_type}
        />
      </div>
    ),
    پویش: (data) => (
      <div>
        <Campaign
          title={section.name_in_view}
          videosBasedOnCategory={data}
          mine={false}
          categoryId={section.categorys?.id}
          tag={!!section.tags?.id}
          tagId={section.tags?.id}
          lg={4}
          md={3}
          type={section.content_type}
        />
      </div>
    ),
  };

  useEffect(() => {
    const fetchSectionData = async () => {
      try {
        const response = await boxFetcher.getBoxContent(section.id);
        if (response) setData(response);
      } catch (err) {
        console.error(`Error fetching section data (ID: ${section.id}):`, err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSectionData();
  }, [section.id]);

  if (loading) return <SkeletonLoader />;
  if (error && section.content_type !== "campaign")
    return <div>خطا در بارگذاری بخش: {section.box_name}</div>;

  let renderContent = sectionComponents[section.box_name];

  if (!renderContent && section.content_type === "campaign") {
    renderContent = sectionComponents["پویش"];
  }

  return (
    <div>
      {renderContent ? (
        renderContent(data)
      ) : (
        <div>این بخش طراحی UI ندارد. : {section.box_name}</div>
      )}
    </div>
  );
};

export default Section;
